import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Moment from "moment/moment"
import {Link} from "react-router-dom"

class HistoryStatisticItem extends Component {
    render() {
        const {type, created, owner, keyword} = this.props.historyStatisticRecord;
        const {name, _id} = owner;
        const now = Moment();
        const createdTime = Moment(created);
        const backwardTime = Moment.duration(createdTime.diff(now));
        return (
            <div className='HistoryStatisticItem'>
                <div className='row table-row'>
                    <div className='col-3'>{keyword}</div>
                    <div className='col-3'>{type}</div>
                    <div className='col-3'>
                        <Link to={`/a/users/${_id}`}>{name}</Link>
                    </div>
                    <div className='col-3'>
                        <div className='tooltip-container'>{backwardTime.humanize(true)}
                            <span
                                className="tooltip-text">{createdTime.format('DD-MM-YYYY')}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

HistoryStatisticItem.propTypes = {
    historyStatisticRecord: PropTypes.object.isRequired,
}

export default HistoryStatisticItem;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/searchHistoryStatistic/searchHisoryStatisticPage/component/HistoryStatisticItem.js